// Offline login-screen demo only. Never used in a production build.
export const MFA_DEMO_EMAIL = 'demo@example.com';
export const MFA_DEMO_PASSWORD = 'DemoPassword1!';
const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';
const storageKey = (username) => `chatty_mfa_demo_${username.trim().toLowerCase()}`;

function encodeBase32(bytes) {
  let bits = 0;
  let value = 0;
  let result = '';
  for (const byte of bytes) {
    value = (value << 8) | byte;
    bits += 8;
    while (bits >= 5) {
      result += alphabet[(value >>> (bits -= 5)) & 31];
    }
  }
  if (bits > 0) result += alphabet[(value << (5 - bits)) & 31];
  return result;
}

function decodeBase32(secret) {
  let bits = 0;
  let value = 0;
  const bytes = [];
  for (const character of secret) {
    const digit = alphabet.indexOf(character);
    if (digit < 0) throw new Error('Invalid demo secret');
    value = (value << 5) | digit;
    bits += 5;
    if (bits >= 8) {
      bytes.push((value >>> (bits -= 8)) & 255);
    }
  }
  return new Uint8Array(bytes);
}

export function startMfaDemo(username) {
  const saved = sessionStorage.getItem(storageKey(username));
  if (saved) return { kind: 'code', secret: saved };
  const bytes = new Uint8Array(20);
  window.crypto.getRandomValues(bytes);
  return { kind: 'setup', secret: encodeBase32(bytes) };
}

export function rememberMfaDemo(username, secret) {
  sessionStorage.setItem(storageKey(username), secret);
}

export async function verifyMfaDemoCode(secret, code, now = Date.now()) {
  if (!/^\d{6}$/.test(code)) return false;
  const key = await window.crypto.subtle.importKey(
    'raw', decodeBase32(secret), { name: 'HMAC', hash: 'SHA-1' }, false, ['sign']
  );
  const currentStep = Math.floor(now / 30000);
  for (let drift = -1; drift <= 1; drift += 1) {
    const step = currentStep + drift;
    if (step < 0) continue;
    const counter = new ArrayBuffer(8);
    const view = new DataView(counter);
    view.setUint32(0, Math.floor(step / 0x100000000));
    view.setUint32(4, step >>> 0);
    const digest = new Uint8Array(await window.crypto.subtle.sign('HMAC', key, counter));
    const offset = digest[digest.length - 1] & 15;
    const value = ((digest[offset] & 127) << 24) |
      (digest[offset + 1] << 16) |
      (digest[offset + 2] << 8) |
      digest[offset + 3];
    if (String(value % 1000000).padStart(6, '0') === code) return true;
  }
  return false;
}
